export const SESSION_KEY = 'session_id'
export const REFERRAL_CODE_KEY = 'referral_code'
export const RESUME_KEY = "resume"
export const WIZARD_CURRENT_PAGE_KEY = "wizard-current-page"
export const WIZARD_FORM_DATA_KEY = "wizard-form-data"